import axios from 'axios';
import toast from 'react-hot-toast';

// ✅ Protection contre /api manquant dans la variable d'env
const rawUrl =
  process.env.REACT_APP_API_URL ||
  'https://sunumarket-api.onrender.com/api';

export const API_URL = rawUrl.endsWith('/api')
  ? rawUrl
  : `${rawUrl}/api`;

export const API_ORIGIN = API_URL.replace(/\/api\/?$/, '');

// ⚠️ 45s : le backend Render (plan gratuit) peut mettre jusqu'à 60s à se
// "réveiller" après 15 min d'inactivité. Avec 15s, la requête mourait avant
// que le serveur ait fini de démarrer. Voir aussi le ping de réveil au
// démarrage de l'app dans index.js.
const api = axios.create({
  baseURL: API_URL,
  timeout: 45000,
  headers: { 'Content-Type': 'application/json' },
});

// ✅ Helper image - TRANSFORMATION CLOUDINARY 800x800 AJOUTÉE
export const resolveImageUrl = (input, fallback) => {
  const url = typeof input === 'string' ? input.trim() : '';
  if (!url) return fallback;
  
  // 🎯 TRANSFORMATION CLOUDINARY : Transforme automatiquement en 800x800 carré
  if (url.includes('cloudinary.com') && url.includes('/upload/')) {
    // c_fill = crop centré pour remplir exactement 800x800
    // q_auto = qualité optimale automatique
    // f_auto = format WebP si supporté (sinon JPG)
    return url.replace('/upload/', '/upload/c_fill,w_800,h_800,q_auto,f_auto/');
  }
  
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  if (url.startsWith('//')) return `${window.location.protocol}${url}`;
  if (url.startsWith('data:') || url.startsWith('blob:')) return url;
  if (url.startsWith('/')) return `${API_ORIGIN}${url}`;
  return `${API_ORIGIN}/${url}`;
};

// ✅ Request interceptor — attach token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Response interceptor — gestion erreurs globale
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const message =
      error.response?.data?.message || 'Une erreur est survenue';

    if (error.response?.status === 401) {
      const currentPath = window.location.pathname;
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      // ✅ Évite la boucle infinie si déjà sur /login
      if (currentPath !== '/login') {
        window.location.href = '/login';
      }
      return Promise.reject(error);
    }

    if (error.response?.status === 403) {
      toast.error('Accès refusé.');
      return Promise.reject(error);
    }

    if (error.response?.status >= 500) {
      toast.error('Erreur serveur. Réessayez plus tard.');
    }

    // ✅ message utilisé dans le reject
    return Promise.reject({ ...error, message });
  }
);

export default api;

// ✅ Format prix FCFA
export const formatPrice = (amount) => {
  return new Intl.NumberFormat('fr-SN', {
    style: 'currency',
    currency: 'XOF',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount || 0);
};

// ✅ Format date fr-SN
export const formatDate = (date) => {
  if (!date) return '';
  try {
    return new Intl.DateTimeFormat('fr-SN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(new Date(date));
  } catch {
    return '';
  }
};